// The documentation sidebar, grouped by what a reader is doing.
export const docNavigation: Array<{ label: string; links: Array<{ to: string; label: string }> }> = [
  {
    label: 'Start',
    links: [
      { to: '/getting-started', label: 'Get Started' },
      { to: '/design-tools', label: 'Design Tools' },
    ],
  },
  {
    label: 'Foundations',
    links: [
      { to: '/foundations', label: 'Overview' },
      { to: '/foundations/color', label: 'Color' },
      { to: '/foundations/typography', label: 'Typography' },
      { to: '/foundations/layout', label: 'Layout' },
      { to: '/foundations/shape', label: 'Shape' },
      { to: '/foundations/motion', label: 'Motion' },
      { to: '/foundations/identity', label: 'Identity' },
    ],
  },
  {
    label: 'Build',
    links: [
      { to: '/components', label: 'Components' },
      { to: '/templates', label: 'Templates' },
      { to: '/patterns', label: 'Patterns' },
      { to: '/missions', label: 'Missions' },
      { to: '/agents', label: 'Agents' },
    ],
  },
  {
    label: 'About',
    links: [
      { to: '/about', label: 'About MDS' },
      { to: '/accessibility', label: 'Accessibility' },
      { to: '/privacy', label: 'Privacy' },
      { to: '/disclaimer', label: 'Disclaimer' },
      { to: '/credits', label: 'Credits' },
      { to: '/license', label: 'License' },
    ],
  },
]

// Header, menu and footer destinations.
export const primaryLinks = [
  { to: '/getting-started', label: 'Get Started' },
  { to: '/foundations', label: 'Foundations' },
  { to: '/components', label: 'Components' },
  { to: '/templates', label: 'Templates' },
  { to: '/patterns', label: 'Patterns' },
  { to: '/missions', label: 'Missions' },
  { to: '/agents', label: 'Agents' },
]
